// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3s2rc","left":"StickyBox_left__24LZM","right":"StickyBox_right__87xre"};